import { AnimatePresence, motion } from 'framer-motion'
import { Button } from 'src/design-system'
import { CaretDown, CaretUp } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { CheckinSkillOutcome } from 'pages/checkin-summary-page/checkin-skills-section/utils'
import { HtmlContent } from 'components/atoms/editor/html-content'
import { Outcome } from 'store/modules/outcomes'

type SkillLevelOutcomesSectionProps = {
  onOpenChange?: (open: boolean) => void
  open?: boolean
  outcomes: CheckinSkillOutcome[] | Outcome[]
}

export const SkillLevelOutcomesSection = observer(
  (props: SkillLevelOutcomesSectionProps) => {
    const { onOpenChange, open: defaultOpen = false, outcomes } = props

    const [open, setOpen] = React.useState(defaultOpen)

    const Icon = open ? CaretUp : CaretDown

    const text = open ? 'Hide' : 'View'

    React.useEffect(() => {
      setOpen(defaultOpen)
    }, [defaultOpen])

    return (
      <AnimatePresence>
        {outcomes.length > 0 && (
          <>
            <Button
              className="bg-transparent border-0 flex focus:shadow-none items-center p-0 text-theme-40 text-sm"
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation()
                onOpenChange?.(!open)
                setOpen(!open)
              }}
            >
              {text} {outcomes.length} examples
              <Icon className="h-4 w-4" />
            </Button>
            {open && (
              <motion.div
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                initial={{ height: 0, opacity: 0 }}
                transition={{ ease: 'easeInOut', duration: 0.2 }}
              >
                <ul className="flex flex-col gap-2 pt-2 mb-0 pl-4 text-sm">
                  {outcomes.map((outcome) => (
                    <li key={outcome.id}>
                      <HtmlContent>{outcome.content}</HtmlContent>
                    </li>
                  ))}
                </ul>
              </motion.div>
            )}
          </>
        )}
      </AnimatePresence>
    )
  }
)
